export enum CountryCode {
  Brazil = "br",
  Chile = "cl",
  Argentina = "ar",
  Colombia = "co"
}
